import { User } from '@/models/user';
import apiClient from '@/api/client';

export interface NewUserDto {
    channelPartnerId: number
    role: string
    firstName?: string
    lastName?: string
    email?: string
  }
  
  export interface UserDto {
    id: string
    email: string
    enabled: boolean
    createdTimestampMs?: number
    createdTimestamp?: string
    firstName: string
    lastName: string
    emailVerified: boolean
    channelPartnerId: number
    accessLevel: string
  }

export const PartnerUserService = {
    async getAll(): Promise<PartnerUserResponse> {
        const response = await apiClient.get<PartnerUserResponse>('/partner/users');
        const result = response.data

        if (!result) {
            throw new Error('Failed to retrieve users.');
        }

        return result;
      },

    async create(firstName: string, lastName: string, email: string, role: string) {
        await apiClient.post('/partner/users', {
            firstName: firstName,
            lastName: lastName,
            email: email,
            role: role
        });
      },

    async update(id: string, firstName: string, lastName: string, email: string, role: string) {
        await apiClient.put(`/partner/users/${id}`, {
            firstName: firstName,
            lastName: lastName,
            email: email,
            role: role
        });
      },

    async delete(id: string) {
        await apiClient.delete(`/partner/users/${id}`);
      }
}

export interface PartnerUserResponse {
    users: User[]
}